<template>
  <div>
    <div class="text-center depahead rsu">Create PIN</div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <v-btn color="primary" @click="query.view = 'OTP'" text class="pl-0">
        <v-icon class="mr-2">mdi-chevron-left</v-icon>BACK
      </v-btn>
      <div style="height: 60px; padding-top: 10px">
        <v-img
          style="margin-left: auto; margin-right: auto"
          width="80px"
          src="../../assets/depa.png"
        ></v-img>
      </div>
      <v-container>
        <div class="text-center mb-5" style="font-size: 20px; font-weight: 600">
          กรอก PIN / PASSWORD
        </div>
        <div style="color: grey">PIN / PASSWORD</div>
        <ValidationObserver ref="observer">
          <ValidationProvider
            name="PIN"
            :key="'PIN'"
            vid="pinnumber"
            :rules="{ required: true }"
            v-slot="{ errors }"
          >
            <div style="position: relative">
              <v-text-field
                name="PIN"
                type="password"
                dense
                :error-messages="errors"
                v-model="input.pin"
                style="border-radius: 6px"
                outlined
                :hide-details="errors.length ? false : true"
              ></v-text-field>
            </div>
          </ValidationProvider>
          <ValidationProvider
            name="PIN"
            :key="'PIN'"
            :rules="{ required: true, confirmed: 'pinnumber' }"
            v-slot="{ errors }"
          >
            <div class="mt-4" style="color: grey">CONFIRM PIN / PASSWORD</div>
            <div style="position: relative">
              <v-text-field
                name="PIN"
                type="password"
                dense
                :error-messages="errors"
                v-model="input.pin_confirm"
                style="border-radius: 6px"
                outlined
                :hide-details="errors.length ? false : true"
              ></v-text-field>
            </div>
          </ValidationProvider>
        </ValidationObserver>
        <div class="submitbtn mt-6">
          <v-btn
            depressed
            :loading="loading"
            @click="login"
            class="text-capitalize"
            color="primary"
            block
            >{{ $store.state.registerStatus ? "LOGIN" : "REGISTER" }}</v-btn
          >
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import api from "@/api";
export default {
  data() {
    return {
      input: { pin: "", pin_confirm: "" },
      loading: false,
    };
  },
  methods: {
    async saveConsent(memberid, sessiontoken) {
      //// บันทึก  Consent ที่เลือก
      if (this.$store.state.consent) {
        this.$store.state.consent.forEach(async (data, index) => {
          // console.log({ data });
          await api.saveConsent(data, memberid, sessiontoken);
        });
        this.$store.state.consent = [];
      }
    },
    async registerData() {
      return new Promise(async (resolve) => {
        var data = {
          userid: this.userid,
          pageid: this.query.pageid,
          password: this.input.pin,
          membertype: this.$store.state.input.usertype,
        };
        if (this.$store.state.registerType == "email") {
          Object.assign(data, {
            email: this.$store.state.input.username,
          });
        } else {
          Object.assign(data, {
            phone_number: this.$store.state.input.username,
          });
        }
        axios
          .post(this.serverUrl + "deparegister", data, {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              await this.saveConsent(
                response.data.data.memberid,
                response.data.sessiontoken
              );
              resolve();
            } else {
              await this.$swal.fire({
                text: response.data.reason,
                confirmButtonText: "ยืนยัน",
                confirmButtonColor: "#152d53",
              });
              if (response.data.responsecode != 300) {
                await this.$liff.closeWindow();
              }
              this.query.view = "Registration";
              resolve();
            }
          });
      });
    },

    async login() {
      if (await this.$refs.observer.validate()) {
        this.loading = true;
        var message = "";
        if (this.$store.state.registerStatus) {
          await this.loginData();
          this.loading = false;
          message = "เข้าสู่ระบบสำเร็จ";
        } else {
          await this.registerData();

          this.loading = false;

          message = "ลงทะเบียนสำเร็จ";
        }
        // await this.sendMessage(message);
        await this.$store.dispatch("sendMessage", message);
        try {
          await this.$liff.closeWindow();
        } catch (error) {
          window.close();
        }
      }
    },
    loginData() {
      return new Promise(async (resolve) => {
        var data = {
          userid: this.userid,
          pageid: this.query.pageid,
          password: this.input.pin,
          membertype: this.$store.state.input.usertype,
        };
        if (this.$store.state.registerType == "email") {
          Object.assign(data, {
            email: this.$store.state.input.username,
          });
        } else {
          Object.assign(data, {
            phone_number: this.$store.state.input.username,
          });
        }
        axios
          .post(this.serverUrl + "depalogin", data, {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              resolve();
            } else {
              await this.$swal.fire("depalogin" + response.data.reason);
              if (response.data.responsecode != 300) {
                await this.$liff.closeWindow();
              }

              resolve();
            }
          });
      });
    },
    sendMessage(message) {
      var vm = this;
      return new Promise(async (resolve) => {
        var url = this.serverUrl + "zwiz-pushmsg-webbrowser";
        var data = {
          pageid: vm.query.pageid,
          userid: vm.$store.state.userid,
          message,
        };
        if (await vm.$liff.isInClient()) {
          try {
            await vm.$liff.sendMessages([
              {
                text: message,
                type: "text",
              },
            ]);
            resolve();
          } catch (error) {
            alert(JSON.stringify(error));
            alert(JSON.stringify(error.message));
          }
        } else {
          axios
            .post(url, data, {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            })
            .then(async (response) => {
              if (response.data.responsecode == 200) {
                resolve();
              } else {
                if (response.data.reason) {
                  await vm.$swal.fire({
                    text: response.data.reason,
                  });
                  resolve();
                }
              }
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
